import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import firebase from "gatsby-plugin-firebase";

// Initial state
const initialState = {
  firstName: null,
  lastName: null,
  username: null,
  photo: null,
  badges: [],
  isLoading: false,
  hasError: false,
  hasFulfilled: false,
};

// Thunks
export const loadSidebar = createAsyncThunk(
  "sidebar/loadSidebar",
  async (user) => {
    try {
      const userSnippetSnap = await firebase
        .firestore()
        .collection("user-snippets")
        .doc(user.uid)
        .get();
      if (userSnippetSnap.exists) {
        // User snippet is available
        return userSnippetSnap.data();
      } else {
        // Return unknown user
        return {
          firstName: null,
          lastName: null,
          username: null,
          photo: null,
        };
      }
    } catch (error) {
      // Log the error to Firebase
      firebase.analytics().logEvent("get_job", {
        errorCode: error.code,
        errorMsg: error.message,
      });

      // Return unknown user
      return {
        firstName: null,
        lastName: null,
        username: null,
        photo: null,
      };
    }
  }
);

// Slice
export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: initialState,
  reducers: {
    setSidebar: (state, action) => action.payload,
    setSidebarPhoto: (state, action) => {
      state.photo = action.payload;
    },
    setSidebarName: (state, action) => {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
    },
    updateSidebar: (state, action) => {
      state[action.payload.field] = action.payload.value;
    },
  },
  extraReducers: {
    [loadSidebar.pending]: (state, action) => {
      state.isLoading = true;
      state.hasError = false;
      state.hasFulfilled = false;
    },
    [loadSidebar.fulfilled]: (state, action) => {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.username = action.payload.username;
      state.photo = action.payload.photo;
      state.isLoading = false;
      state.hasError = false;
      state.hasFulfilled = true;
    },
    [loadSidebar.rejected]: (state, action) => {
      state.isLoading = false;
      state.hasError = true;
      state.hasFulfilled = true;
    },
  },
});

// Selectors
export const selectSidebar = (state) => state.sidebar;
export const selectUsername = (state) => state.sidebar.username;
export const selectIsLoading = (state) => state.sidebar.isLoading;
export const selectHasError = (state) => state.sidebar.hasError;
export const selectHasFulfilled = (state) => state.sidebar.hasFulfilled;

// Exports
export const { setSidebar, setSidebarPhoto, setSidebarName, updateSidebar } =
  sidebarSlice.actions;
export default sidebarSlice.reducer;
